<template>
    <div class="container tercero-page">
        <div class="param-title-wrap">
            <b-button class="page-back-btn mr-2" variant="link" @click="goBack">
                <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" />
            </b-button>
            <h2 class="param-title">{{labels.title}}</h2>
        </div>
        <!-- <pre>{{ listActivos }}</pre> -->
        <div class="tercero-table-block mt-4" v-if="listActivos.length > 0">
            <CorporateDataTable
                :items="activosFormat"
                :fields="allFields"
                :filter-defs="tableFilterDefs"                
                :default-per-page="10"
                :page-options="[10, 15, 20, 50, 100]"
                :narrow="false"
                :table-min-height="500"
                :table-max-height="500"
            ></CorporateDataTable>
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-else>
            <h5>{{ labels.noRow }}</h5> 
        </div>
    </div>
</template>

<script>
import CorporateDataTable from '../utils/CorporateDataTable.vue'
import ContratoActivo from '../../services/ContratoActivo'; 
import Activos from '../../services/Activos' 
import TipoActivo from '../../services/TipoActivo'; 
import Tercero from '../../services/Tercero'; 

export default {
    name : 'ConsultarActivos',
    components : {CorporateDataTable},
    data(){
        return {
            listActivos : [],
            activos : [],
            lstTipoActivo : [],
            lstProveedor : [],
        }
    },
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Lista activos',
                    noRow : 'No hay registros',
                    contrato : 'Contrato',
                    tipoActivo : 'Tipo activo',
                    descripcion : 'Descripción',
                    proveedor : 'Proveedor',
                    valorCompra : 'Valor compra',
                    valorSalvamento : 'Valor salvamento',
                    valorAmortizado : 'Valor amortizado',
                    fechaCompra : 'Fecha compra',
                    filterContrato : 'Filtrar contrato...',
                    filterTipoActivo : 'Filtrar tipo activo...',
                    filterDescripcion : 'Filtrar descripción...',
                    filterProveedor : 'Filtrar proveedor...',
                    filterValorCompra : 'Filtrar valor compra...',
                    filterValorSalvamento : 'Filtrar valor salvamento...',
                    filterValorAmortizado : 'Filtrar valor amortizado...',
                    filterFechaCompra : 'Filtrar fecha compra...',
                }
            }else{
                return {
                    title : 'List of assets',
                    noRow : 'No records found',
                    contrato : 'Contract',
                    tipoActivo : 'Active type',
                    descripcion : 'Description',
                    proveedor : 'Provider',
                    valorCompra : 'Purchase value',
                    valorSalvamento : 'Salvage value',
                    valorAmortizado : 'Amortized value',
                    fechaCompra : 'Purchase date',
                    filterContrato : 'Filter contract...',
                    filterTipoActivo : 'Filter by asset type...',
                    filterDescripcion : 'Filter description...',
                    filterProveedor : 'Filter provider...',
                    filterValorCompra : 'Filter purchase value...',
                    filterValorSalvamento : 'Filter salvage value...',
                    filterValorAmortizado : 'Filter amortized value...',
                    filterFechaCompra : 'Filter by purchase date...',
                }
            }
        },
        allFields(){
            return [
                { key: 'nro_contrato', label: this.labels.contrato, sortable: true, thClass: 'text-center', tdClass: 'text-center' },
                { key: 'activo', label: this.labels.tipoActivo, sortable: true, thClass: 'text-center', tdClass: 'text-start' },
                { key: 'descripcion', label: this.labels.descripcion, sortable: true, thClass: 'text-center', tdClass: 'text-start' },
                { key: 'proveedor', label: this.labels.proveedor, sortable: true, thClass: 'text-center', tdClass: 'text-start' },
                { key: 'valor_compra', label: this.labels.valorCompra, sortable: true, thClass: 'text-center', tdClass: 'text-end' },
                { key: 'valor_salvamento', label: this.labels.valorSalvamento, sortable: true, thClass: 'text-center', tdClass: 'text-end' },
                { key: 'valor_amortizado', label: this.labels.valorAmortizado, sortable: true, thClass: 'text-center', tdClass: 'text-end' },
                { key: 'fecha_compra', label: this.labels.fechaCompra, sortable: true, thClass: 'text-center', tdClass: 'text-start' },
            ]
        },
        tableFilterDefs(){
            return [
                { key: 'nro_contrato', type: 'text', placeholder: this.labels.filterContrato },
                { key: 'tipo_activo', type: 'text', placeholder: this.labels.filterTipoActivo },
                { key: 'descripcion', type: 'text', placeholder: this.labels.filterDescripcion },
                { key: 'proveedor', type: 'text', placeholder: this.labels.filterProveedor },
                { key: 'valor_compra', type: 'text', placeholder: this.labels.filterValorCompra },
                { key: 'valor_salvamento', type: 'text', placeholder: this.labels.filterValorSalvamento },
                { key: 'valor_amortizado', type: 'text', placeholder: this.labels.filterValorAmortizado },
                { key: 'fecha_compra', type: 'text', placeholder: this.labels.filterFechaCompra },
            ]
        },
        activosFormat() {
            return this.listActivos.map(item => ({
                ...item,
                activo: this.tipoActivo(item.activo),
                descripcion: this.descripcionActivo(item.activo),
                proveedor: this.proveedor(item.activo),
                valor_compra: this.valCompra(item.activo),
                valor_salvamento: this.valSalvamento(item.activo),
                valor_amortizado: this.valAmortizado(item.activo),
                fecha_compra: this.fechaCompra(item.activo),
            }));
        }
    },
    methods:{
        goBack(){
            this.$router.back()
        },
        tipoActivo(numActivo) {
            const activo = this.activos.find(a => a.activo == numActivo);

            if (!activo) return '';

            const tipo = this.lstTipoActivo.find(
                t => t.tipo_activo == activo.tipo_activo
            );
            return tipo?.descripcion ?? '';
        },
        descripcionActivo(numActivo){
            let name = this.activos.find((activo) => activo.activo == numActivo) 
            return name?.descripcion 
        },
        proveedor(numActivo) {
            const activo = this.activos.find(a => a.activo == numActivo);

            if (!activo) return '';

            const proveedor = this.lstProveedor.find(
                p => p.identificacion == activo.proveedor
            );
            return proveedor?.nombre ?? '';
        },
        valCompra(numActivo){
            let valor = this.activos.find((activo) => activo.activo == numActivo) 
            return Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(valor?.valor_compra) 
        },
        valSalvamento(numActivo){
            let valor = this.activos.find((activo) => activo.activo == numActivo) 
            return Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(valor?.valor_salvamento) 
        },
        valAmortizado(numActivo){
            let valor = this.activos.find((activo) => activo.activo == numActivo) 
            return Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(valor?.valor_amortizado) 
        },
        fechaCompra(numActivo){
            let fecha = this.activos.find((activo) => activo.activo == numActivo) 
            return fecha?.fecha_compra 
        }
    },
    mounted(){
        const numContrato = this.$route.params.contrato;

        ContratoActivo.getActivoContratoByNumContr(numContrato) 
        .then((res) => { 
            // console.log(res.data.activosContrato); 
            this.listActivos = res.data.activosContrato 
        })
        .catch((err) => console.log(err)) 

        Activos.getAllActivos() 
        .then((res) => { 
            // console.log(res.data.listActivos); 
            this.activos = res.data.listActivos 
            console.log(this.activos[0],'getAllActivos');
        })
        .catch((err) => console.log(err)) 

        TipoActivo.getAllTipoActivo() 
        .then((res) => { 
            // console.log(res.data.listTipoActivo); 
            this.lstTipoActivo = res.data.listTipoActivo 
        })
        .catch((err) => console.log(err)) 

        Tercero.getAllTercero() 
        .then((res) => { 
            // console.log(res.data.listTercero); 
            this.lstProveedor = res.data.listTercero 
        })
        .catch((err) => console.log(err)) 
    }
}
</script>

<style>

</style>